import { AsyncPipe, DatePipe, NgIf, NgTemplateOutlet } from '@angular/common';
import { NgModule } from '@angular/core';
import { PromoCmsComponents } from '@core/const';
import { InViewportDirective } from '@sdvor/shared/ui';
import { CmsConfig, ConfigModule } from '@spartacus/core';
import { GenericLinkComponent } from '@spartacus/storefront';
import { SdBannerContentModule } from '../banner-content';
import { SdTimestampResponsiveBannerComponent } from './timestamp-responsive-banner.component';

@NgModule({
  declarations: [SdTimestampResponsiveBannerComponent],
  imports: [
    NgIf,
    NgTemplateOutlet,
    AsyncPipe,
    DatePipe,
    GenericLinkComponent,
    SdBannerContentModule,
    InViewportDirective,
    ConfigModule.withConfig(<CmsConfig>{
      cmsComponents: {
        [PromoCmsComponents.TimestampResponsiveBannerComponent]: {
          component: SdTimestampResponsiveBannerComponent,
        },
      },
    }),
  ],
})
export class SdTimestampResponsiveBannerModule {}
